module.exports = __webpack_public_path__ + "static/media/GuideStar-logo.28716826.svg";